import { BadgeCheck } from "lucide-react";
import { Overline, Reveal } from "./Reveal";
import { IMAGES } from "../../lib/site";

const CREDENTIALS = [
  "Psicóloga formada pela UFTM — Universidade Federal do Triângulo Mineiro",
  "Especialista em Saúde pela FAMERP — Faculdade de Medicina de São José do Rio Preto/SP",
  "Pós-graduação em Terapia Familiar Sistêmica",
  "Mais de 8 anos de experiência no acompanhamento de adultos",
];

export const About = () => (
  <section
    id="sobre"
    data-testid="about-section"
    className="py-24 lg:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <h2 className="max-w-3xl font-serif text-3xl font-normal leading-tight tracking-tight text-bark sm:text-4xl lg:text-5xl">
          Conheça quem vai caminhar{" "}
          <span className="italic text-brand">ao seu lado</span> nesse processo
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 items-center gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal>
          <div className="relative mx-auto max-w-sm">
            <div className="absolute -top-6 -left-6 h-full w-full rounded-[2rem] border border-clay/40" />
            <div className="relative overflow-hidden rounded-[2rem] shadow-[0_24px_48px_rgba(45,51,47,0.14)]">
              <img
                src={IMAGES.portrait}
                alt="Vanessa Calsavara, psicóloga, em seu consultório"
                className="aspect-[4/5] w-full object-cover object-center"
                data-testid="about-portrait"
              />
            </div>
            <div className="absolute -bottom-5 -right-4 rounded-2xl bg-brand px-5 py-3 shadow-[0_16px_32px_rgba(58,77,57,0.3)]">
              <p className="font-serif text-lg font-medium italic text-sand">
                Prazer, Vanessa.
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7 lg:pl-6">
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-moss sm:text-lg">
            Minha trajetória na área da saúde me mostrou que o sofrimento
            emocional raramente acontece de forma isolada. Ele atravessa
            relações, muda a rotina, desafia identidades e exige novas formas de
            adaptação. É a partir dessa compreensão que conduzo cada processo
            terapêutico: considerando não apenas os sintomas, mas a história, os
            vínculos e o contexto de vida de cada pessoa.
          </p>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-moss sm:text-lg">
            No consultório, você encontrará um espaço de escuta acolhedora,
            respeito e construção conjunta. Mais do que oferecer respostas
            prontas, meu compromisso é ajudar você a compreender sua história,
            fortalecer seus recursos emocionais e desenvolver formas mais
            saudáveis de lidar consigo, com seus relacionamentos e com os
            desafios da vida.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <ul className="mt-10 space-y-4">
            {CREDENTIALS.map((item, i) => (
              <li
                key={i}
                data-testid={`about-credential-${i}`}
                className="flex items-start gap-3"
              >
                <BadgeCheck className="mt-0.5 h-5 w-5 shrink-0 text-brand" strokeWidth={1.8} />
                <span className="text-sm font-medium leading-relaxed text-bark sm:text-base">
                  {item}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
      </div>
    </div>
  </section>
);
